import { combineReducers } from 'redux';
import workfloweditor from './workfloweditor/reducer';
import templateeditor from './templateeditor/reducer';
import userList from './usersgroups/users/reducer';
import groupList from './usersgroups/groups/reducer';
import formeditor from './formeditor/reducer';
import tags from './tags/reducer';
import { messageBoxReducer } from './helpers/MessageUtility';
import subscription from './subscription/reducer';
import reports from './reports/reducer';
import profile from './profile/reducer';
import { SASTOKEN_GET_SUCCESS, SASTOKEN_GET_FAILURE, GET_USERINFO_SUCCESS, CLIENT_LOCKED } from './actions';
import { produce } from 'immer';
import { SharedState, UserInfoAction, UserInfoState } from 'gf-types';
import onboarding from './welcome/choosejourney/reducer';
import userPersistedState from './persistedstate/users/reducer';
import hipaaSetupReducer from './settings/hipaa/reducer';
import { notificationsReducer } from './notifications/reducer';
import clientPersistedState from './persistedstate/clients/reducer';
import publicFormPersistedState from './persistedstate/publicforms/reducer';

const initialState = {} as SharedState;

const shared = (state: SharedState = initialState, action) => {
  if (!action) return state;

  return produce(state, (draft) => {
    switch (action.type) {
      case SASTOKEN_GET_SUCCESS:
      case SASTOKEN_GET_FAILURE:
        return { ...draft, ...action.payload };

      case CLIENT_LOCKED:
        draft.clientLocked = true;
        return draft;

      default:
        return draft;
    }
  });
};

const userInfo = (state: UserInfoState = {} as UserInfoState, action: UserInfoAction) => {
  if (!action) return state;

  return produce(state, (draft) => {
    switch (action.type) {
      case GET_USERINFO_SUCCESS:
        return { ...draft, ...action.payload, ...{ loaded: true } };

      default:
        return draft;
    }
  });
};

const reducer = combineReducers({
  shared,
  workfloweditor,
  templateeditor,
  userList,
  groupList,
  formeditor,
  profile,
  notificationCenter: notificationsReducer,
  messages: messageBoxReducer,
  tags,
  subscription,
  reports,
  userInfo,
  onboarding,
  userPersistedState,
  clientPersistedState,
  publicFormPersistedState,
  hipaaSetup: hipaaSetupReducer
});

export default reducer;
